module.exports = __webpack_public_path__ + "img/daydreaming_1.20f9c099.png";